export const AdvStorage = {
  getCookie: (): number[] => JSON.parse(getCookieByName(SHOW_MODAL_KEY) || '[]'),
  addToCookie: (advId: number) => setSessionCookie(SHOW_MODAL_KEY, JSON.stringify([...AdvStorage.getCookie(), advId])),
  getLocalStorage: (): number[] => JSON.parse(localStorage.getItem(SHOW_MODAL_KEY) || '[]'),
  addToLocalStorage: (advId: number) => updateLocalStorage([...AdvStorage.getLocalStorage(), advId]),
  removeFromLocalStorage: (advId: number) => updateLocalStorage(AdvStorage.getLocalStorage().filter(id => advId !== id)),
};

const SHOW_MODAL_KEY = 'z-adv-show-modal';

const updateLocalStorage = (data: number[]) => localStorage.setItem(SHOW_MODAL_KEY, JSON.stringify(data));

const setSessionCookie = (name: string, value: string) => (document.cookie = name + '=' + (value || '') + ';domain=.zanichelli.it;path=/;');

const getCookieByName = (name: string) => {
  const nameEQ = name + '=';
  const cookiesArray = document.cookie.split(';');
  const cookie = cookiesArray.find((cookie: string) => cookie.trim().indexOf(nameEQ) == 0);
  if (cookie) return cookie.trim().substring(nameEQ.length, cookie.trim().length);
};
